// A declined meeting stays in the user's data (Google keeps it on their
// calendar), but nothing should prompt them about it: no reminder, no blink,
// no "Next up". `response` is set by parseFetchedEvents, `userEventResponse`
// by the Calendar page parser.
export const isDeclinedEvent = (event) =>
  event?.response === "declined" || event?.userEventResponse === "declined";
